import {
  BATCHES_INDEX_REQUESTED,
  BATCHES_INDEX_SUCCESS,
  BATCHES_INDEX_FAILURE,
  BATCHES_STATS_REQUESTED,
  BATCHES_STATS_SUCCESS,
  BATCHES_STATS_FAILURE,
  BATCH_FIND_REQUESTED,
  BATCH_FIND_SUCCESS,
  BATCH_FIND_FAILURE,
} from '../types';

const INITIAL_STATE = {
  batches: [],
  statusCounts: null,
  activeBatch: null,
  isFetching: false,
  isFetchingMore: false,
  isFetchingStats: false,
  isFinding: false,
  lastPage: false,
  continuationToken: null,
  status: 'waiting',
  errors: null
};

const mergeBatches = (currentBatches, newBatches) => {
  const mergedBatches = new Map();

  [...currentBatches, ...newBatches].forEach((batch) => {
    mergedBatches.set(batch.id, batch);
  });

  return Array.from(mergedBatches.values());
};

const batches = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case BATCHES_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: !action.append,
        isFetchingMore: action.append,
        status: 'requesting',
        errors: null
      });

    case BATCHES_INDEX_SUCCESS: {
      const newBatches = action.payload.batches || [];

      return Object.assign({}, state, {
        batches: action.append ? mergeBatches(state.batches, newBatches) : newBatches,
        isFetching: false,
        isFetchingMore: false,
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        status: 'success',
        errors: null
      });
    }

    case BATCHES_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchingMore: false,
        status: 'error',
        errors: action.error
      });

    case BATCHES_STATS_REQUESTED:
      return Object.assign({}, state, {
        isFetchingStats: true,
        errors: null
      });

    case BATCHES_STATS_SUCCESS:
      return Object.assign({}, state, {
        statusCounts: action.payload.status_counts,
        isFetchingStats: false
      });

    case BATCHES_STATS_FAILURE:
      return Object.assign({}, state, {
        isFetchingStats: false,
        errors: action.error
      });

    case BATCH_FIND_REQUESTED:
      return Object.assign({}, state, {
        activeBatch: null,
        isFinding: true,
        status: 'requesting',
        errors: null
      });

    case BATCH_FIND_SUCCESS:
      return Object.assign({}, state, {
        activeBatch: action.payload,
        isFinding: false,
        status: 'success',
        errors: null
      });

    case BATCH_FIND_FAILURE:
      return Object.assign({}, state, {
        activeBatch: null,
        isFinding: false,
        status: 'error',
        errors: action.error
      });

    default:
      return state;
  }
};

export default batches;
